import { FieldProps, useRecordContext } from "react-admin";

import { get } from "lodash";
import { ReactJsonEditor } from "@/src/components";


export function JsonField(props: Partial<FieldProps>) {
    const { source, className } = props;
    const record = useRecordContext(props)
    const value = source ? get(record, source) : record;

    return value && <ReactJsonEditor content={{ json: value }} className={className} readOnly />

}